export default "__VITE_ASSET__DH9m$J4y__"